module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/index-25.vue");


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/index.md
// module id = 718
// module chunks = 0